import { useEffect, useRef } from 'react';

/**
 * When a dialog is open, browser/mobile Back dismisses it instead of leaving the page.
 * Also locks body scroll and closes on Escape.
 */
export default function useHistoryBackClose(isOpen, onClose, historyKey = 'modalOpen') {
  const closedByPopRef = useRef(false);

  useEffect(() => {
    if (!isOpen) return undefined;

    closedByPopRef.current = false;
    document.body.style.overflow = 'hidden';
    window.history.pushState({ [historyKey]: true }, '');

    const handlePopState = () => {
      closedByPopRef.current = true;
      onClose();
    };

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };

    window.addEventListener('popstate', handlePopState);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('popstate', handlePopState);
      document.removeEventListener('keydown', handleKeyDown);

      if (!closedByPopRef.current && window.history.state?.[historyKey]) {
        window.history.back();
      }
    };
  }, [isOpen, onClose, historyKey]);
}
